import { AuthContext, FireactContext, SetPageTitle } from "../lib/core";
import { Alert, Box, Button, Card, CardActions, CardHeader, CardMedia, CardContent, Container, Paper, Typography, TextField } from "@mui/material";
import Grid from '@mui/material/Grid2';
import React, { useContext, useEffect, useState, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { httpsCallable } from "firebase/functions";
import { Stack } from "@mui/system";
import { collection, query, where, getDocs, getDoc, doc, documentId, addDoc, setDoc, arrayUnion, Timestamp, orderBy, limit, onSnapshot } from 'firebase/firestore';
import { getStorage, ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import { useParams, Outlet } from 'react-router-dom';
import InfoDialog from "./InfoDialog";
import ChatDialog from "./ChatDialog";
import ChatIcon from '@mui/icons-material/Chat';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import {PageSection} from "../template/TemplateElements";
import Avatar from '@mui/material/Avatar';
import { styled } from '@mui/material/styles';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import { green } from '@mui/material/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ProductCard from "./ProductCard";
import SendIcon from '@mui/icons-material/Send';
import Rating from '@mui/material/Rating';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { v4 as uuid, v5 as uuidv5 } from 'uuid';
import ImagesDropzone from "./imagesDropzone";
import ImageElement from "./imageElement";
import LoadingButton from '@mui/lab/LoadingButton';
import dayjs from 'dayjs';
import Link from '@mui/material/Link';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import ImageFullScreenDialog from "./ImageFullScreenDialog";
import ScheduleCard from "./ScheduleCard";

const Appointment = ({loader}) => {

    const { authInstance, firestoreInstance, functionsInstance } = useContext(AuthContext);
    const { config } = useContext(FireactContext);
    const navigate = useNavigate();
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(null);
    const [processing, setProcessing] = useState(false);
    const { authUser } = useContext(AuthContext);
    const { appointmentId } = useParams();
    const [openInfoDialog, setOpenInfoDialog] = useState(false);
    const [openChatDialog, setOpenChatDialog] = useState(false);
    const [dialogInfo, setDialogInfo] = useState(null);
    const [reviews, setReviews] = useState([]);
    const [schedule, setSchedule] = useState(null);
    const ref = React.useRef(null);
    
    //console.log('appointmentId ', appointmentId);

    useEffect(() => {
        setLoaded(false);
        setError(null);
        // get default permission level name
        let defaultPermission = '';
        for(var permission in config.saas.permissions){
            const value = config.saas.permissions[permission];
            if(value.default){
                defaultPermission = permission;
            }
        }

        //setLoaded(true);
        
    },[authInstance, config.saas.permissions, firestoreInstance]);

    const getScheduleDetails = useCallback(async (appointmentId) => {
        //get schedule (appointment)
        const scheduleRef = doc(firestoreInstance, "schedules", appointmentId);
        const scheduleSnap = await getDoc(scheduleRef);
        if (scheduleSnap.exists()) {
            const schedule = scheduleSnap.data();
            setSchedule({...schedule, scheduleId:scheduleSnap.id});
            // if there's no amountReceived field in the schedule, that means the appointment is Pay On Service. We can let user to pay on this page.
            //console.log('schedule', schedule);
        }
        setLoaded(true);
    }, [appointmentId]);

    useEffect(() => {
        getScheduleDetails(appointmentId);
    },[getScheduleDetails]);

    return (
        <>
            {loaded ? (
              <>
                <Container maxWidth={false} disableGutters>
                    <SetPageTitle title={`Appointment Details`} />
                    <Box sx={{ flexGrow: 1, p: 2, width: '100%', minHeight: '100vh'}} >
                        <Grid container spacing={0}>
                            <Grid size={{ xs: 12, md: 12 }}>
                                <Card sx={{ width: '100%' }} align="left">
                                    <CardHeader
                                        avatar={
                                            <CardMedia
                                            component="img"
                                            sx={{ maxHeight: 56, maxWidth: 56, bgcolor: green[50], borderRadius: 1, p: '4px', width: 56, height: 56, mr: 1}}
                                            image={schedule.treatment.image}
                                            alt={schedule.treatment.name}
                                            />
                                        }
                                        title={schedule.treatment.name}
                                        subheader={
                                            <>
                                                <Typography>
                                                {`${schedule.time}, ${schedule.date}${schedule.year ? ', '+schedule.year : ''}`}
                                                </Typography>
                                                <Typography sx={{fontSize: 11}}>
                                                ${schedule.totalPrice} - {(schedule.amountReceived > 0) ? `Paid $${schedule.amountReceived/100}`: (schedule.amountReceived === 0) ? 'Paid with Free Coupon' : 'Pay on Service'}
                                                </Typography>
                                            </>
                                        }
                                    />
                                </Card>
                            </Grid>
                            <Grid size={{ xs: 12, md: 12 }}>
                                {schedule && (
                                    <>
                                    <ScheduleCard schedule={schedule} scrollRef={ref} paid={schedule.amountReceived ? true : false} snackbarMessage={""}/>
                                    </>
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                </Container>
              </>
            ):(
                <>{loader}</>
            )}
        </>
    )
}

export default Appointment;